import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

///FIX THIS AS PER BUSINESS REQUIREMENT
@Pipe({
    name: 'noteTimeDate',
    standalone: false
})
export class NoteTimeDatePipe implements PipeTransform {

  transform(value: Date): string {
    if (value === null) {
      return 'null';
    }
    
    const datePipe = new DatePipe('en-US');
    const dayOfWeek = datePipe.transform(value, 'EEEE');
    const dayOfMonth = datePipe.transform(value, 'd');
    const time = datePipe.transform(value, 'HH:mm');
    const timeZone = datePipe.transform(value, 'z');

    return `${dayOfWeek} ${dayOfMonth} at ${time} ${timeZone}`;
  }

}
